import {
  OreButton,
  OreTable,
  OreTableActions,
  OreTableBody,
  OreTableCaption,
  OreTableCell,
  OreTableContainer,
  OreTableRow,
  OreText,
  SvgPlus,
} from '@edenredespana/oreneta'
import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useTpv } from '@/Store/ui/context'
import { AddTpvModal, AddTpvModalActions } from '@/Store/ui/molecules'
import { storesTranslation } from '@/Store/ui/storesTranslation'

export const TpvsList = (): JSX.Element => {
  const ref = useRef<AddTpvModalActions>(null)
  const { t } = useTranslation()

  const { model, loadTpvs } = useTpv()

  useEffect(() => {
    if (!model.length) loadTpvs()
  }, [])

  return (
    <>
      <OreTableContainer>
        <OreTable>
          <OreTableCaption title={t(storesTranslation.tpvs.list.title)} />
          <OreTableBody valign="top">
            {model && model.length
              ? model.map(item => (
                  <OreTableRow key={item.terminalMid}>
                    <OreTableCell>
                      <OreText size="text-sm" tone="neutral-900" bold>
                        {item.terminalMid}
                      </OreText>
                    </OreTableCell>
                  </OreTableRow>
                ))
              : null}
          </OreTableBody>
        </OreTable>
        {model && model.length ? null : (
          <OreTableActions>
            <OreText size="text-sm" tone="neutral-900" data-testid="noTpvs">
              {t(storesTranslation.tpvs.list.noTpvs)}
            </OreText>
          </OreTableActions>
        )}
        <OreTableActions>
          <OreButton
            data-testid="addTpv"
            category="highlight"
            icon={<SvgPlus />}
            iconAlign="right"
            onClick={() => ref?.current?.open()}
          >
            {t(storesTranslation.tpvs.list.add)}
          </OreButton>
        </OreTableActions>
      </OreTableContainer>
      <AddTpvModal ref={ref} />
    </>
  )
}
